import createHistory from 'history/createBrowserHistory'

//history router
export const history = createHistory({basename:process.env.PUBLIC_URL});





// WEBPACK FOOTER //
// ./src/routes/history.ts